import React from 'react';
import './App.css';
import { Background, Hero, HowTo, FeatureList, BeforeAfter, Footer } from './components';

function App() {
  return (
    <div className="app">
      <Background />
      <main className="container">
        <Hero />
        <HowTo />
        <FeatureList />
        <BeforeAfter />
        <Footer />
      </main>
    </div>
  );
}

export default App;
